import React from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

function EmojiBullet(props) {
    const { text } = props;

    return (
        <Box
            component="li"
            display="flex"
            alignItems="center"
            sx={{
                py: 0.65,
                fontSize: "1.05rem",
                lineHeight: 1.5,
                cursor: "default"
            }}
        >
            <StarIcon
                sx={{
                    color: "#3b82f6",
                    fontSize: "1.3rem",
                    mr: 1.5,
                    verticalAlign: "middle",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                }}
            />
            <Typography variant="body1" component="span" sx={{ fontSize: "1.02rem" }}>
                {text}
            </Typography>
        </Box>
    );
}

export default EmojiBullet;
